import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=0a5b1a84&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5b1a84')) {
      api.createRecord('0a5b1a84', component.options)
    } else {
      api.reload('0a5b1a84', component.options)
    }
    module.hot.accept("./ChangeStatus.vue?vue&type=template&id=0a5b1a84&", function () {
      api.rerender('0a5b1a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ChangeStatus.vue"
export default component.exports